import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { FILTER_USER_LOG } from 'src/app/graphql/logs.graphql';

@Injectable({
  providedIn: 'root'
})
export class UserLogService {

  constructor(private apollo: Apollo) { }

  /**
    * Função responsável por filtrar os logs
    */
  filterLogs(
    company: string | null,
    operation: any | null,
    startDatetime: any | null,
    endDatetime: any | null,
    userUserName: any | null,
    targetUsername: any | null,
    cursor: string | null,
    first: number | null
  ): any {

    return this.apollo.watchQuery({
      query: FILTER_USER_LOG,
      fetchPolicy: 'network-only',
      variables: {
        company,
        operation,
        startDatetime,
        endDatetime,
        userUserName,
        targetUsername,
        first,
        cursor
      }
    })
  }
}
